import { initialCardioPm } from './../store/cardio.reducers'
import { select, put, takeLatest, call } from 'redux-saga/effects'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { resetInvasiveMonitoring, resetPacemaker } from '../store/cardio.actions'
import { TripInformationConstants } from '../../../tripInformation/store/tripInformation.constants'
import { getTripInformationSelector } from '../../../tripInformation/selectors'
import { getServiceIdSelector } from '../../../user/selectors'
import { getPcrIdSelector } from '../../../home/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { IPcr } from '../../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* resetPacemakerInvasiveMonitoring() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated = { ...pcrDoc }
    let didPcrDocUpdated = false

    try {
      const { staffingLevel } = yield select(getTripInformationSelector)

      if (staffingLevel?.isAls !== 1) {
        yield put(resetPacemaker())

        if (pcrDocUpdated.prPm) {
          pcrDocUpdated.prPm = [{ ...initialCardioPm }]
          didPcrDocUpdated = true
        }
      }

      if (staffingLevel?.id !== 4) {
        yield put(resetInvasiveMonitoring())

        if (pcrDocUpdated.prNabc) {
          pcrDocUpdated.prNabc = {
            ...pcrDocUpdated.prNabc,
            cvArt: [],
            cvSwan: null,
          }
          didPcrDocUpdated = true
        }
      }
      if (didPcrDocUpdated) {
        yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      }
    } catch (e) {
      yield put(throwPcrException(`resetPacemakerInvasiveMonitoring() error: ${e}`))
    }
  }
}
export function* resetPacemakerInvasiveMonitoringSaga() {
  yield takeLatest([TripInformationConstants.SET_STAFFING_LEVEL], performWithMutexHOG, resetPacemakerInvasiveMonitoring)
}
